export function getQmTypeLabel(type: string | null | undefined, typeLabel?: string | null | undefined): string {
  const resolvedTypeLabel = String(typeLabel || '').trim();
  if (resolvedTypeLabel) return resolvedTypeLabel;

  if (!type) return '-';
  if (type === 'INBOUND') return 'Inbound';
  if (type === 'SITE_INBOUND') return 'Site Inbound';

  return type;
}
